import styled from "styled-components";

export const SupportDiv = styled.div`
  margin: 0 auto;
  padding: 20px;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 910px) {
    width: 85%;
  }
`;
export const Text = styled.p`
  margin: ${({ margin }) => margin && margin};
  max-width: ${({ maxWidth }) => maxWidth && maxWidth};
  font-size: 14px;
  font-weight: ${({ fontWeight }) => fontWeight && fontWeight};
  color: #000;
  text-align: center;
`;
export const Span = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: #000;
`;
export const Link = styled.a`
  font-size: 14px;
  font-weight: bold;
`;
